import './FooterComponent.css';
import FuegoInfinito from '../../Assets/Images/FallasInfinitas.png';
import Instagram from '../../Assets/Svg/instagram.svg';
import Ticktoc from '../../Assets/Svg/tiktok.svg';
import Facebook from '../../Assets/Svg/facebook.svg';
import Twitter from '../../Assets/Svg/x.svg';
import Junta from '../../Assets/Svg/fjfs.svg';
import Youtube from '../../Assets/Svg/youtube.svg';
import { Link } from 'react-router-dom';
import Copyright from '../../Assets/Svg/copyright.svg';

export const Footer = (props) => {
    return (
        <div className="footer">
            <div className="fuegosvg">
                <img src={FuegoInfinito} alt="FuegoInfinito" className="fuego" />
            </div>
            <div className="info-footer">
                <div className="socials-section">
                    <h1>{props.I18n.OurSocialNetworks}</h1>
                    <div className="nuestras-redes">
                        <Link to="https://www.instagram.com/fallaplazarodrigo/?hl=es" target="_blank" rel="noopener noreferrer">
                            <img src={Instagram} alt="Instagram" className="instagram" />
                        </Link>
                        <Link to="https://www.tiktok.com/discover/falla-plaza-rodrigo" target="_blank" rel="noopener noreferrer">
                            <img src={Ticktoc} alt="Ticktoc" className="ticktoc" />
                        </Link>
                        <Link to="https://m.facebook.com/100080158465131/?locale=es_ES" target="_blank" rel="noopener noreferrer">
                            <img src={Facebook} alt="Facebook" className="facebook" />
                        </Link>
                        <Link to="https://twitter.com/fallaplzrodrigo?lang=es" target="_blank" rel="noopener noreferrer">
                            <img src={Twitter} alt="Twitter" className="twitter" />
                        </Link>
                        <Link to="https://fjfs.es/es/placa-rodrigo-3/" target="_blank" rel="noopener noreferrer">
                            <img src={Junta} alt="Junta" className="junta" />
                        </Link>
                        <Link to="https://www.youtube.com/@fallaplazarodrigo" target="_blank" rel="noopener noreferrer">
                            <img src={Youtube} alt="Youtube" className="youtube" />
                        </Link>
                    </div>
                </div>
                <div className="legal-section">
                    <h1>{props.I18n.Legal}</h1>
                    <div className="informacion-legal">
                        <Link to="/terminos-y-condiciones" className="terminios-condiciones">
                            {props.I18n.TermsAndConditions}
                        </Link>
                        <Link to="/politica-de-privacidad" className="politica-privacidad">
                            {props.I18n.PrivacyPolicies}
                        </Link>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <div className="copyright-line copyright-falla">
                    <img src={Copyright} alt="Copyright" />
                    <p>{props.I18n.PlazaRodrigoFalla} {new Date().getFullYear()}</p>
                </div>
                <p className="copyright-line copyright-unesco">{props.I18n.LesFalles}</p>
                <p className="copyright-line copyright-credit">
                    Web/app hecha por{' '}
                    <a
                        href="https://alexiglesias.vercel.app/#about"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="copyright-credit-link"
                    >
                        Alex Iglesias Fernández
                    </a>
                </p>
            </div>
        </div>
    );
};
